import { orgAPI } from "@/api/api";
import { IntegrationConnection } from "@cohesive/api-client";
import {
  GmailEmailThreadEntity,
  GmailThreadsListInput,
} from "@cohesive/api-entities";
import { useInfiniteQuery } from "@tanstack/react-query";

export function useGmailThreadsList(
  connection: IntegrationConnection,
  input: GmailThreadsListInput = {},
) {
  return useInfiniteQuery({
    queryKey: ["gmail-threads-list", connection.id, input],
    queryFn: ({ pageParam = {} }) => {
      return orgAPI.toolbox.execute<GmailEmailThreadEntity[]>({
        integration_connection_id: connection.id,
        action_name: "gmail-threads-list",
        action_input: {
          ...input,
          ...pageParam,
        },
        // Typed entities drive the rich thread cards; their generic projections
        // ride along in data_generic and are what get placed on the canvas.
        entity_format: "both",
      });
    },
    getNextPageParam: (lastPage) => {
      return lastPage.pagination?.next;
    },
    initialPageParam: {},
  });
}
